export { Rating } from './rating';
export { StarIcon } from './star-symbol/star-icon';
export type { RatingStylesNames, RatingProps } from './rating';
